// src/redux/slices/cartSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  addToCartAPI,
  fetchCartAPI,
  removeFromCartAPI,
  updateCartAPI,
} from "./cartAPI";

// --- Thunks ---
export const fetchCart = createAsyncThunk("cart/fetchCart", async () => {
  const res = await fetchCartAPI();
  return res.data;
});

export const addToCart = createAsyncThunk(
  "cart/addToCart",
  async (payload, { dispatch }) => {
    await addToCartAPI(payload);
    dispatch(fetchCart()); // ✅ refresh cart
  }
);

export const updateCart = createAsyncThunk(
  "cart/updateCart",
  async ({ id, qty}, { dispatch }) => {
    await updateCartAPI({
      id: id,
      qty,
    });
    dispatch(fetchCart())
  }
);

export const removeFromCart = createAsyncThunk(
  "cart/removeFromCart",
  async (id, { dispatch }) => {
    await removeFromCartAPI({id: id});
    dispatch(fetchCart()); // ✅ refresh cart
  }
);

// --- Slice ---
const cartSlice = createSlice({
  name: "cart",
  initialState: {
    items: [],
    totalSummary: {},
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      // LIST
      .addCase(fetchCart.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCart.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.items || action.payload || []; // ✅ safe
        state.totalSummary = action.payload.summary || {};
      })
      .addCase(fetchCart.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default cartSlice.reducer;
